import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { deepExtend, isArray } from "../../../../Utils/Utils";
var charKey = "character",
    charAltKey = "char",
    imageKey = "image",
    imageAltKey = "images",
    polygonKey = "polygon",
    polygonAltKey = "star";
export var Shape = /*#__PURE__*/function () {
  function Shape() {
    var _this = this;

    _classCallCheck(this, Shape);

    this.loadShape = function (item, mainKey, altKey, altOverride) {
      var _this$options$mainKey;

      if (!item) {
        return;
      }

      var itemIsArray = isArray(item),
          emptyValue = itemIsArray ? [] : {},
          mainDifferentValues = itemIsArray !== isArray(_this.options[mainKey]),
          altDifferentValues = itemIsArray !== isArray(_this.options[altKey]);

      if (mainDifferentValues) {
        _this.options[mainKey] = emptyValue;
      }

      if (altDifferentValues && altOverride) {
        _this.options[altKey] = emptyValue;
      }

      _this.options[mainKey] = deepExtend((_this$options$mainKey = _this.options[mainKey]) !== null && _this$options$mainKey !== void 0 ? _this$options$mainKey : emptyValue, item);

      if (!_this.options[altKey] || altOverride) {
        var _this$options$altKey;

        _this.options[altKey] = deepExtend((_this$options$altKey = _this.options[altKey]) !== null && _this$options$altKey !== void 0 ? _this$options$altKey : emptyValue, item);
      }
    };

    this.close = true;
    this.fill = true;
    this.options = {};
    this.type = "circle";
  }

  _createClass(Shape, [{
    key: "character",
    get: function get() {
      var _this$options$charKey;

      return (_this$options$charKey = this.options[charKey]) !== null && _this$options$charKey !== void 0 ? _this$options$charKey : this.options[charAltKey];
    },
    set: function set(value) {
      this.options[charAltKey] = this.options[charKey] = value;
    }
  }, {
    key: "custom",
    get: function get() {
      return this.options;
    },
    set: function set(value) {
      this.options = value;
    }
  }, {
    key: "image",
    get: function get() {
      var _this$options$imageKe;

      return (_this$options$imageKe = this.options[imageKey]) !== null && _this$options$imageKe !== void 0 ? _this$options$imageKe : this.options[imageAltKey];
    },
    set: function set(value) {
      this.options[imageAltKey] = this.options[imageKey] = value;
    }
  }, {
    key: "images",
    get: function get() {
      return this.image;
    },
    set: function set(value) {
      this.image = value;
    }
  }, {
    key: "polygon",
    get: function get() {
      var _this$options$polygon;

      return (_this$options$polygon = this.options[polygonKey]) !== null && _this$options$polygon !== void 0 ? _this$options$polygon : this.options[polygonAltKey];
    },
    set: function set(value) {
      this.options[polygonAltKey] = this.options[polygonKey] = value;
    }
  }, {
    key: "stroke",
    get: function get() {
      return [];
    },
    set: function set(_value) {}
  }, {
    key: "load",
    value: function load(data) {
      var _data$options, _data$image;

      if (!data) {
        return;
      }

      var options = (_data$options = data.options) !== null && _data$options !== void 0 ? _data$options : data.custom;

      if (options !== undefined) {
        for (var shape in options) {
          var item = options[shape];

          if (item) {
            var _this$options$shape;

            this.options[shape] = deepExtend((_this$options$shape = this.options[shape]) !== null && _this$options$shape !== void 0 ? _this$options$shape : {}, item);
          }
        }
      }

      this.loadShape(data.character, charKey, charAltKey, true);
      this.loadShape(data.polygon, polygonKey, polygonAltKey, false);
      this.loadShape((_data$image = data.image) !== null && _data$image !== void 0 ? _data$image : data.images, imageKey, imageAltKey, true);

      if (data.close !== undefined) {
        this.close = data.close;
      }

      if (data.fill !== undefined) {
        this.fill = data.fill;
      }

      if (data.type !== undefined) {
        this.type = data.type;
      }
    }
  }]);

  return Shape;
}();